import Invoice from './columns/invoice';
import Total from './columns/total';
import InvoiceDate from './columns/invoiceDate';
import InvoiceDue from './columns/invoiceDue';
import PDF from './columns/pdf';
import FilterInvoice from './columns/filterInvoice';
import InvoiceDateFormatted from './columns/InvoiceDateFormatted';
import InvoiceDueFormatted from './columns/InvoiceDueFormatted';
import TotalFormatted from './columns/TotalFormatted';
import PaymentStatus from './columns/PaymentStatus';

const invoiceColumns = [
  Invoice,
  Total,
  InvoiceDate,
  InvoiceDue,
  PaymentStatus,
  PDF,
  TotalFormatted,
  InvoiceDateFormatted,
  InvoiceDueFormatted,
  FilterInvoice
];

export default invoiceColumns;
